import { useContext, useEffect, useState } from "react"
import { LoadingSpinner } from "../LoadingSpinner"
import { VibratoClientContext } from "./contexts"

export default function NewSubscription() {
  const client = useContext(VibratoClientContext)
  const [, setIsPolling] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [initialPlan, setInitialPlan] = useState<any>(null)

  useEffect(() => {
    let pollInterval: number
    let timeoutTimer: number

    const pollForPlanUpdate = async () => {
      try {
        // Get initial plan to compare against
        if (!initialPlan) {
          const plan = await client.getPlan()
          setInitialPlan(plan)
          return
        }

        // Poll for updated plan
        const currentPlan = await client.getPlan()
        console.log("Current plan", currentPlan)
        if (!currentPlan) {
          console.log("No current plan")
          return
        }
        if (!currentPlan.subscription_updated_at) {
          console.log("No subscription updated at")
          return
        }

        const updatedAt = new Date(currentPlan.subscription_updated_at)
        const now = new Date()
        const timeDiff = now.getTime() - updatedAt.getTime()

        // If the update is within the last 1 minutes, consider it recent
        if (timeDiff < 60 * 1000) {
          setIsPolling(false)
          // Use full page refresh to redirect
          console.log("New subscription detected, redirecting to dashboard")
          window.location.href = "/dashboard?subscription_success=true"
          return
        }
      } catch (err) {
        console.error("Error polling for plan update:", err)
        setError("Failed to check subscription status. Please try refreshing the page.")
        setIsPolling(false)
      }
    }

    // Start polling every 2 seconds
    pollInterval = window.setInterval(pollForPlanUpdate, 2000)

    // Set timeout for 1 minute
    timeoutTimer = window.setTimeout(() => {
      setIsPolling(false)
      clearInterval(pollInterval)
      // Redirect to dashboard even if we didn't detect the update
      window.location.href = "/dashboard?subscription_success=true"
    }, 60000)

    // Initial fetch
    pollForPlanUpdate()

    return () => {
      clearInterval(pollInterval)
      clearTimeout(timeoutTimer)
    }
  }, [client, initialPlan])

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] p-8">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md text-center">
          <div className="text-red-600 font-medium mb-2">Subscription Update Error</div>
          <p className="text-red-700 text-sm mb-4">{error}</p>
          <button
            onClick={() => (window.location.href = "/settings/plan")}
            className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 transition-colors"
          >
            Go to Billing Settings
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-8">
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-8 max-w-md text-center">
        <LoadingSpinner className="w-8 h-8 mx-auto mb-4 text-indigo-600" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Processing Your Subscription</h2>
        <p className="text-gray-600 mb-4">
          We're confirming your subscription changes. This usually takes just a few seconds.
        </p>
        <div className="text-sm text-gray-500">Please don't close this page while we process your subscription...</div>
      </div>
    </div>
  )
}
